/* eslint-disable array-callback-return */
import React from "react";

const ListItem = ({ list, dispatch }) => {
  const handleDelete = (id) => {
    const actionDelete = {
      type: "delete",
      payload: id,
    };
    dispatch(actionDelete);
  };
  const handleCheck = (id) => {
    const actionCheck = {
      type: "check",
      payload: id,
    };
    dispatch(actionCheck);
  };

  return (
    <div className="list">
      <div className="list__container">
        {list.map((list) => {
          return (
            <div className="list__cards" key={list.id}>
              <div className="list__cards-title">
                <h3
                  style={{
                    textDecoration: list.done ? "line-through" : "none",
                  }}
                >
                  {list.producto}
                </h3>
              </div>
              <div className="list__cards-cantidad">
                <p
                  style={{
                    textDecoration: list.done ? "line-through" : "none",
                  }}
                >
                  {list.cant_peso}
                </p>
              </div>
              <div>
                <button
                  onClick={() => handleCheck(list.id)}
                  className="list__btn list__btn--green"
                >
                  <i className="fas fa-check fa-4x" aria-hidden="true"></i>
                </button>
                <button
                  onClick={() => handleDelete(list.id)}
                  className="list__btn list__btn--red"
                >
                  <i className="fas fa-times fa-4x" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListItem;
